import firebase from 'firebase'
import 'firebase/auth'

const app = firebase.initializeApp({
  apiKey: "AIzaSyDIITGjVy4_cm1phSMmm_QF9uLRcCjhz08",
  authDomain: "theplatformapp.firebaseapp.com",
  projectId: "theplatformapp",
  storageBucket: "theplatformapp.appspot.com",
  messagingSenderId: "552074509029",
  appId: "1:552074509029:web:7240ec5da1a0c24aa3b20c",
  measurementId: "G-SD2QMH92TL"
});

const db = app.firestore()
const auth = firebase.auth()
const storage = firebase.storage()



export { db,storage,auth }